export const countries = [
  { code: 'ITA', name_it: 'Italia', name_en: 'Italy' },
  { code: 'AFG', name_it: 'Afghanistan', name_en: 'Afghanistan' },
  { code: 'ALB', name_it: 'Albania', name_en: 'Albania' },
  { code: 'DZA', name_it: 'Algeria', name_en: 'Algeria' },
  { code: 'AND', name_it: 'Andorra', name_en: 'Andorra' },
  { code: 'AGO', name_it: 'Angola', name_en: 'Angola' },
  { code: 'ARG', name_it: 'Argentina', name_en: 'Argentina' },
  { code: 'ARM', name_it: 'Armenia', name_en: 'Armenia' },
  { code: 'AUS', name_it: 'Australia', name_en: 'Australia' },
  { code: 'AUT', name_it: 'Austria', name_en: 'Austria' },
  { code: 'AZE', name_it: 'Azerbaigian', name_en: 'Azerbaijan' },
  { code: 'BHS', name_it: 'Bahamas', name_en: 'Bahamas' },
  { code: 'BHR', name_it: 'Bahrein', name_en: 'Bahrain' },
  { code: 'BGD', name_it: 'Bangladesh', name_en: 'Bangladesh' },
  { code: 'BRB', name_it: 'Barbados', name_en: 'Barbados' },
  { code: 'BLR', name_it: 'Bielorussia', name_en: 'Belarus' },
  { code: 'BEL', name_it: 'Belgio', name_en: 'Belgium' },
  { code: 'BLZ', name_it: 'Belize', name_en: 'Belize' },
  { code: 'BEN', name_it: 'Benin', name_en: 'Benin' },
  { code: 'BTN', name_it: 'Bhutan', name_en: 'Bhutan' },
  { code: 'BOL', name_it: 'Bolivia', name_en: 'Bolivia' },
  { code: 'BIH', name_it: 'Bosnia ed Erzegovina', name_en: 'Bosnia and Herzegovina' },
  { code: 'BWA', name_it: 'Botswana', name_en: 'Botswana' },
  { code: 'BRA', name_it: 'Brasile', name_en: 'Brazil' },
  { code: 'BRN', name_it: 'Brunei', name_en: 'Brunei' },
  { code: 'BGR', name_it: 'Bulgaria', name_en: 'Bulgaria' },
  { code: 'BFA', name_it: 'Burkina Faso', name_en: 'Burkina Faso' },
  { code: 'BDI', name_it: 'Burundi', name_en: 'Burundi' },
  { code: 'KHM', name_it: 'Cambogia', name_en: 'Cambodia' },
  { code: 'CMR', name_it: 'Camerun', name_en: 'Cameroon' },
  { code: 'CAN', name_it: 'Canada', name_en: 'Canada' },
  { code: 'CPV', name_it: 'Capo Verde', name_en: 'Cape Verde' },
  { code: 'CAF', name_it: 'Repubblica Centrafricana', name_en: 'Central African Republic' },
  { code: 'TCD', name_it: 'Ciad', name_en: 'Chad' },
  { code: 'CHL', name_it: 'Cile', name_en: 'Chile' },
  { code: 'CHN', name_it: 'Cina', name_en: 'China' },
  { code: 'COL', name_it: 'Colombia', name_en: 'Colombia' },
  { code: 'COM', name_it: 'Comore', name_en: 'Comoros' },
  { code: 'COG', name_it: 'Congo', name_en: 'Congo' },
  { code: 'COD', name_it: 'Repubblica Democratica del Congo', name_en: 'Democratic Republic of the Congo' },
  { code: 'CRI', name_it: 'Costa Rica', name_en: 'Costa Rica' },
  { code: 'CIV', name_it: 'Costa d\'Avorio', name_en: 'Ivory Coast' },
  { code: 'HRV', name_it: 'Croazia', name_en: 'Croatia' },
  { code: 'CUB', name_it: 'Cuba', name_en: 'Cuba' },
  { code: 'CYP', name_it: 'Cipro', name_en: 'Cyprus' },
  { code: 'CZE', name_it: 'Repubblica Ceca', name_en: 'Czech Republic' },
  { code: 'DNK', name_it: 'Danimarca', name_en: 'Denmark' },
  { code: 'DJI', name_it: 'Gibuti', name_en: 'Djibouti' },
  { code: 'DMA', name_it: 'Dominica', name_en: 'Dominica' },
  { code: 'DOM', name_it: 'Repubblica Dominicana', name_en: 'Dominican Republic' },
  { code: 'ECU', name_it: 'Ecuador', name_en: 'Ecuador' },
  { code: 'EGY', name_it: 'Egitto', name_en: 'Egypt' },
  { code: 'SLV', name_it: 'El Salvador', name_en: 'El Salvador' },
  { code: 'GNQ', name_it: 'Guinea Equatoriale', name_en: 'Equatorial Guinea' },
  { code: 'ERI', name_it: 'Eritrea', name_en: 'Eritrea' },
  { code: 'EST', name_it: 'Estonia', name_en: 'Estonia' },
  { code: 'ETH', name_it: 'Etiopia', name_en: 'Ethiopia' },
  { code: 'FJI', name_it: 'Figi', name_en: 'Fiji' },
  { code: 'FIN', name_it: 'Finlandia', name_en: 'Finland' },
  { code: 'FRA', name_it: 'Francia', name_en: 'France' },
  { code: 'GAB', name_it: 'Gabon', name_en: 'Gabon' },
  { code: 'GMB', name_it: 'Gambia', name_en: 'Gambia' },
  { code: 'GEO', name_it: 'Georgia', name_en: 'Georgia' },
  { code: 'DEU', name_it: 'Germania', name_en: 'Germany' },
  { code: 'GHA', name_it: 'Ghana', name_en: 'Ghana' },
  { code: 'GRC', name_it: 'Grecia', name_en: 'Greece' },
  { code: 'GRD', name_it: 'Grenada', name_en: 'Grenada' },
  { code: 'GTM', name_it: 'Guatemala', name_en: 'Guatemala' },
  { code: 'GIN', name_it: 'Guinea', name_en: 'Guinea' },
  { code: 'GNB', name_it: 'Guinea-Bissau', name_en: 'Guinea-Bissau' },
  { code: 'GUY', name_it: 'Guyana', name_en: 'Guyana' },
  { code: 'HTI', name_it: 'Haiti', name_en: 'Haiti' },
  { code: 'HND', name_it: 'Honduras', name_en: 'Honduras' },
  { code: 'HUN', name_it: 'Ungheria', name_en: 'Hungary' },
  { code: 'ISL', name_it: 'Islanda', name_en: 'Iceland' },
  { code: 'IND', name_it: 'India', name_en: 'India' },
  { code: 'IDN', name_it: 'Indonesia', name_en: 'Indonesia' },
  { code: 'IRN', name_it: 'Iran', name_en: 'Iran' },
  { code: 'IRQ', name_it: 'Iraq', name_en: 'Iraq' },
  { code: 'IRL', name_it: 'Irlanda', name_en: 'Ireland' },
  { code: 'ISR', name_it: 'Israele', name_en: 'Israel' },
  { code: 'JAM', name_it: 'Giamaica', name_en: 'Jamaica' },
  { code: 'JPN', name_it: 'Giappone', name_en: 'Japan' },
  { code: 'JOR', name_it: 'Giordania', name_en: 'Jordan' },
  { code: 'KAZ', name_it: 'Kazakistan', name_en: 'Kazakhstan' },
  { code: 'KEN', name_it: 'Kenya', name_en: 'Kenya' },
  { code: 'KIR', name_it: 'Kiribati', name_en: 'Kiribati' },
  { code: 'PRK', name_it: 'Corea del Nord', name_en: 'North Korea' },
  { code: 'KOR', name_it: 'Corea del Sud', name_en: 'South Korea' },
  { code: 'KWT', name_it: 'Kuwait', name_en: 'Kuwait' },
  { code: 'KGZ', name_it: 'Kirghizistan', name_en: 'Kyrgyzstan' },
  { code: 'LAO', name_it: 'Laos', name_en: 'Laos' },
  { code: 'LVA', name_it: 'Lettonia', name_en: 'Latvia' },
  { code: 'LBN', name_it: 'Libano', name_en: 'Lebanon' },
  { code: 'LSO', name_it: 'Lesotho', name_en: 'Lesotho' },
  { code: 'LBR', name_it: 'Liberia', name_en: 'Liberia' },
  { code: 'LBY', name_it: 'Libia', name_en: 'Libya' },
  { code: 'LIE', name_it: 'Liechtenstein', name_en: 'Liechtenstein' },
  { code: 'LTU', name_it: 'Lituania', name_en: 'Lithuania' },
  { code: 'LUX', name_it: 'Lussemburgo', name_en: 'Luxembourg' },
  { code: 'MKD', name_it: 'Macedonia del Nord', name_en: 'North Macedonia' },
  { code: 'MDG', name_it: 'Madagascar', name_en: 'Madagascar' },
  { code: 'MWI', name_it: 'Malawi', name_en: 'Malawi' },
  { code: 'MYS', name_it: 'Malesia', name_en: 'Malaysia' },
  { code: 'MDV', name_it: 'Maldive', name_en: 'Maldives' },
  { code: 'MLI', name_it: 'Mali', name_en: 'Mali' },
  { code: 'MLT', name_it: 'Malta', name_en: 'Malta' },
  { code: 'MHL', name_it: 'Isole Marshall', name_en: 'Marshall Islands' },
  { code: 'MRT', name_it: 'Mauritania', name_en: 'Mauritania' },
  { code: 'MUS', name_it: 'Mauritius', name_en: 'Mauritius' },
  { code: 'MEX', name_it: 'Messico', name_en: 'Mexico' },
  { code: 'FSM', name_it: 'Micronesia', name_en: 'Micronesia' },
  { code: 'MDA', name_it: 'Moldavia', name_en: 'Moldova' },
  { code: 'MCO', name_it: 'Monaco', name_en: 'Monaco' },
  { code: 'MNG', name_it: 'Mongolia', name_en: 'Mongolia' },
  { code: 'MNE', name_it: 'Montenegro', name_en: 'Montenegro' },
  { code: 'MAR', name_it: 'Marocco', name_en: 'Morocco' },
  { code: 'MOZ', name_it: 'Mozambico', name_en: 'Mozambique' },
  { code: 'MMR', name_it: 'Myanmar', name_en: 'Myanmar' },
  { code: 'NAM', name_it: 'Namibia', name_en: 'Namibia' },
  { code: 'NRU', name_it: 'Nauru', name_en: 'Nauru' },
  { code: 'NPL', name_it: 'Nepal', name_en: 'Nepal' },
  { code: 'NLD', name_it: 'Paesi Bassi', name_en: 'Netherlands' },
  { code: 'NZL', name_it: 'Nuova Zelanda', name_en: 'New Zealand' },
  { code: 'NIC', name_it: 'Nicaragua', name_en: 'Nicaragua' },
  { code: 'NER', name_it: 'Niger', name_en: 'Niger' },
  { code: 'NGA', name_it: 'Nigeria', name_en: 'Nigeria' },
  { code: 'NOR', name_it: 'Norvegia', name_en: 'Norway' },
  { code: 'OMN', name_it: 'Oman', name_en: 'Oman' },
  { code: 'PAK', name_it: 'Pakistan', name_en: 'Pakistan' },
  { code: 'PLW', name_it: 'Palau', name_en: 'Palau' },
  { code: 'PAN', name_it: 'Panama', name_en: 'Panama' },
  { code: 'PNG', name_it: 'Papua Nuova Guinea', name_en: 'Papua New Guinea' },
  { code: 'PRY', name_it: 'Paraguay', name_en: 'Paraguay' },
  { code: 'PER', name_it: 'Perù', name_en: 'Peru' },
  { code: 'PHL', name_it: 'Filippine', name_en: 'Philippines' },
  { code: 'POL', name_it: 'Polonia', name_en: 'Poland' },
  { code: 'PRT', name_it: 'Portogallo', name_en: 'Portugal' },
  { code: 'QAT', name_it: 'Qatar', name_en: 'Qatar' },
  { code: 'ROU', name_it: 'Romania', name_en: 'Romania' },
  { code: 'RUS', name_it: 'Russia', name_en: 'Russia' },
  { code: 'RWA', name_it: 'Ruanda', name_en: 'Rwanda' },
  { code: 'KNA', name_it: 'Saint Kitts e Nevis', name_en: 'Saint Kitts and Nevis' },
  { code: 'LCA', name_it: 'Santa Lucia', name_en: 'Saint Lucia' },
  { code: 'VCT', name_it: 'Saint Vincent e Grenadine', name_en: 'Saint Vincent and the Grenadines' },
  { code: 'WSM', name_it: 'Samoa', name_en: 'Samoa' },
  { code: 'SMR', name_it: 'San Marino', name_en: 'San Marino' },
  { code: 'STP', name_it: 'São Tomé e Príncipe', name_en: 'São Tomé and Príncipe' },
  { code: 'SAU', name_it: 'Arabia Saudita', name_en: 'Saudi Arabia' },
  { code: 'SEN', name_it: 'Senegal', name_en: 'Senegal' },
  { code: 'SRB', name_it: 'Serbia', name_en: 'Serbia' },
  { code: 'SYC', name_it: 'Seychelles', name_en: 'Seychelles' },
  { code: 'SLE', name_it: 'Sierra Leone', name_en: 'Sierra Leone' },
  { code: 'SGP', name_it: 'Singapore', name_en: 'Singapore' },
  { code: 'SVK', name_it: 'Slovacchia', name_en: 'Slovakia' },
  { code: 'SVN', name_it: 'Slovenia', name_en: 'Slovenia' },
  { code: 'SLB', name_it: 'Isole Salomone', name_en: 'Solomon Islands' },
  { code: 'SOM', name_it: 'Somalia', name_en: 'Somalia' },
  { code: 'ZAF', name_it: 'Sudafrica', name_en: 'South Africa' },
  { code: 'SSD', name_it: 'Sudan del Sud', name_en: 'South Sudan' },
  { code: 'ESP', name_it: 'Spagna', name_en: 'Spain' },
  { code: 'LKA', name_it: 'Sri Lanka', name_en: 'Sri Lanka' },
  { code: 'SDN', name_it: 'Sudan', name_en: 'Sudan' },
  { code: 'SUR', name_it: 'Suriname', name_en: 'Suriname' },
  { code: 'SWE', name_it: 'Svezia', name_en: 'Sweden' },
  { code: 'CHE', name_it: 'Svizzera', name_en: 'Switzerland' },
  { code: 'SYR', name_it: 'Siria', name_en: 'Syria' },
  { code: 'TWN', name_it: 'Taiwan', name_en: 'Taiwan' },
  { code: 'TJK', name_it: 'Tagikistan', name_en: 'Tajikistan' },
  { code: 'TZA', name_it: 'Tanzania', name_en: 'Tanzania' },
  { code: 'THA', name_it: 'Tailandia', name_en: 'Thailand' },
  { code: 'TLS', name_it: 'Timor Est', name_en: 'East Timor' },
  { code: 'TGO', name_it: 'Togo', name_en: 'Togo' },
  { code: 'TON', name_it: 'Tonga', name_en: 'Tonga' },
  { code: 'TTO', name_it: 'Trinidad e Tobago', name_en: 'Trinidad and Tobago' },
  { code: 'TUN', name_it: 'Tunisia', name_en: 'Tunisia' },
  { code: 'TUR', name_it: 'Turchia', name_en: 'Turkey' },
  { code: 'TKM', name_it: 'Turkmenistan', name_en: 'Turkmenistan' },
  { code: 'TUV', name_it: 'Tuvalu', name_en: 'Tuvalu' },
  { code: 'UGA', name_it: 'Uganda', name_en: 'Uganda' },
  { code: 'UKR', name_it: 'Ucraina', name_en: 'Ukraine' },
  { code: 'ARE', name_it: 'Emirati Arabi Uniti', name_en: 'United Arab Emirates' },
  { code: 'GBR', name_it: 'Regno Unito', name_en: 'United Kingdom' },
  { code: 'USA', name_it: 'Stati Uniti', name_en: 'United States' },
  { code: 'URY', name_it: 'Uruguay', name_en: 'Uruguay' },
  { code: 'UZB', name_it: 'Uzbekistan', name_en: 'Uzbekistan' },
  { code: 'VUT', name_it: 'Vanuatu', name_en: 'Vanuatu' },
  { code: 'VAT', name_it: 'Vaticano', name_en: 'Vatican City' },
  { code: 'VEN', name_it: 'Venezuela', name_en: 'Venezuela' },
  { code: 'VNM', name_it: 'Vietnam', name_en: 'Vietnam' },
  { code: 'YEM', name_it: 'Yemen', name_en: 'Yemen' },
  { code: 'ZMB', name_it: 'Zambia', name_en: 'Zambia' },
  { code: 'ZWE', name_it: 'Zimbabwe', name_en: 'Zimbabwe' }
];